import React from 'react';
import './CallToAction.css';

function CallToAction() {
  return (
    <section id="contact" className="section cta-section">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Transform Your Outdoor Space?</h2>
          <p className="cta-text">
            Contact us today for a free consultation. Let's bring your landscaping vision to life.
          </p>
          <div className="cta-buttons">
            <button className="btn-primary cta-btn-primary">Get a Free Quote</button>
            <button className="btn-secondary cta-btn-secondary">Call Us Now</button>
          </div>
          <div className="cta-contact-info">
            <span>
              <strong>Phone:</strong> <a href="tel:+919981206128">+91 99812 06128</a>, <a href="tel:+916264573743">+91 62645 73743</a>
            </span>
            <span>
              <strong>Email:</strong><br />
              <a href="mailto:heavengreeninfra0@gmail.com">heavengreeninfra0@gmail.com</a>
            </span>
            <span>
              <strong>Address:</strong> Near Maa Sharda Public School, Main Road Kathadih, Mathpurena, Raipur
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;